import { Category, StateUtils } from '@spartacus/core';
import { CATEGORY } from '../custom-category-state';

export enum CustomCategoryActionTypes {
  LOAD_CATEGORY = '[Category] Load Category',
  LOAD_CATEGORY_SUCCESS = '[Category] Load Category Success',
  LOAD_CATEGORY_FAIL = '[Category] Load Category Fail'
}

export class LoadCategory {
  readonly type = CustomCategoryActionTypes.LOAD_CATEGORY;

  constructor(public payload: { code: string }) {}
}

export class LoadCategoryFail extends StateUtils.LoaderFailAction {
  readonly type = CustomCategoryActionTypes.LOAD_CATEGORY_FAIL;

  constructor(public payload: any) {
    super(CATEGORY, payload);
  }
}

export class LoadCategorySuccess {
  readonly type = CustomCategoryActionTypes.LOAD_CATEGORY_SUCCESS;
  constructor(public payload: Category) {}
}

// action types
export type CustomCategoryListActions = LoadCategory | LoadCategoryFail | LoadCategorySuccess;
